<ng-container *ngIf="renderRouter">
  <router-outlet></router-outlet>
</ng-container>
